var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49224 5.50008L0.209056 1.21668C-0.0696856 0.938066 -0.0696856 0.48758 0.209056 0.208963C0.487668 -0.0696543 0.938144 -0.0696543 1.21676 0.208963L5.50007 4.49236L9.78324 0.208963C10.062 -0.0696543 10.5123 -0.0696543 10.7909 0.208963C11.0697 0.48758 11.0697 0.938066 10.7909 1.21668L6.50776 5.50008L10.7909 9.78348C11.0697 10.0621 11.0697 10.5126 10.7909 10.7912C10.6521 10.9302 10.4695 11 10.2871 11C10.1047 11 9.92222 10.9302 9.78324 10.7912L5.50007 6.5078L1.21676 10.7912C1.07778 10.9302 0.895341 11 0.712906 11C0.530471 11 0.348036 10.9302 0.209056 10.7912C-0.0696856 10.5126 -0.0696856 10.0621 0.209056 9.78348L4.49224 5.50008Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordError);
export default __webpack_public_path__ + "static/media/password_error.104e8ee7bf3c9bb2cd354a89f14b885f.svg";
export { ForwardRef as ReactComponent };